import { render, staticRenderFns } from "./index.vue?vue&type=template&id=1e488bfb&scoped=true"
import script from "./index.vue?vue&type=script&lang=js"
export * from "./index.vue?vue&type=script&lang=js"
import style0 from "./index.vue?vue&type=style&index=0&id=1e488bfb&lang=css"
import style1 from "./index.vue?vue&type=style&index=1&id=1e488bfb&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1e488bfb",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("D:\\work\\baby_doctor_platform\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('1e488bfb')) {
      api.createRecord('1e488bfb', component.options)
    } else {
      api.reload('1e488bfb', component.options)
    }
    module.hot.accept("./index.vue?vue&type=template&id=1e488bfb&scoped=true", function () {
      api.rerender('1e488bfb', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/RightPanel/index.vue"
export default component.exports